<template>
    <div class="box-second">
        <p class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>质量BIM</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
             <div v-if="myURL && myURL!=''" class="bim-link" style="position: absolute;top:0;left:0;width:100%;height:100%;background: #fff;">
                <iframe width="100%" :src='myURL' frameborder="no" style="border: 0;height: 100%;"></iframe>
            </div>
            <div v-else style="width:100%;height:100%;position: relative;display: flex;justify-content: center;align-content: center;background:#fff;align-items: center;">
                暂无数据
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../untils/util';
export default {
    data(){
        return{
            myURL:'',
        }
    },
    mounted(){
        if(util.session.get('groupId')=='1203536946790273025'){
            this.myURL = '/data/webBim.html';
        }else if(util.session.get('groupId')=='1308697053488082946'){
            this.myURL = '/data/webBimZky.html';
        }else{
            this.myURL = '/data/webBimOther.html';
        }
    },
    methods:{
        
    }
}
</script>
<style scoped>
    .box-second{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .title{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 1vw;
    }
    /* .main{
        width: 100%;
        height: calc( 100% - 4vh );
        position: relative;
        display: flex;
        padding: 0 1vw 0.5vw;
        overflow: hidden;
    } */
</style>
<style>
@import '../../assets/css/common.css';
</style>